import { useDispatch, useSelector } from 'react-redux';

import { actions, customActions_template } from '@redux/actions';

//_____________________ TEMPLATE ______________ //

//landing
export const useTemplate_landing = () => {
	const landing = useSelector((state) => state.template.landing);
	const dispatch = useDispatch();

	return {
		state: landing,
		actions: customActions_template.landing,
		dispatch: dispatch,
		setState: (values = {}, scope = '') => dispatch(actions.template_landing_set(values, scope)),
		clearState: (values = {}, scope = '') => dispatch(actions.template_landing_clear(values, scope)),
	};
};
